export default "__VITE_ASSET__BmG7PHuq__"